export default __webpack_public_path__ + "media/images/alert-c3e30e523cdeb78b977391d6f61d289a.png";